module.exports = __webpack_public_path__ + "static/media/a55.a0f5d994.jpg";